import { updateDeliveryMethodApi } from "api/shopping-cart/updateDeliveryMethodApi";
import { refreshShoppingCart } from "./refreshShoppingCart";

export function setDeliveryMethod(method: any) {
  return (dispatch: any) => {
    updateDeliveryMethodApi(method)
      .then(() => {
        dispatch(refreshShoppingCart(null, { loader: true }));
      });
  };
}
